import { apiurl } from "configs/config";
import axios from "axios";

export const GetTransactionDataById=async(id)=>{
    try {
        const res=await axios?.get(`${apiurl}/api/Transaction/GetTransactionDataById?Id=${id}`)
        return res?.data
    } catch (error) {
        console.log(error,"error on fetching data");
    }
    
}
export const GetIssueDataById=async(id)=>{
    try {
        const res=await axios?.get(`${apiurl}/api/Transaction/GetTransactionDataById?Id=${id}`)
        return res?.data
    } catch (error) {
        console.log(error,"error on fetching data");
    }
    
}